import React from 'react';
import { Btn } from './index.jsx';
import { palette, type } from '../design';


// Suspense with a reload offer instead of a blank panel (TTT-76).
//
// A deploy rebuilds /srv from scratch, so the previous build's content-hashed chunk files are
// gone. A visitor still holding the old page asks for a chunk that no longer exists, the dynamic
// import rejects, and React.lazy re-throws it during render. With no boundary above it the whole
// panel rendered empty, and nothing told the reader to reload.
//
// Two different things throw in here and they need different copy. A missing chunk is fixed by
// reloading; a genuine render bug is not, and telling that reader "a new version is available"
// sends them round a loop that never ends.
const STALE_CHUNK = /dynamically imported module|Importing a module script failed|Failed to load module script/i;

export class LazyPanel extends React.Component {
  state = { error: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error) {
    console.error('A lazy-loaded panel failed to render', error);
  }

  render() {
    const { error } = this.state;
    if (!error) {
      return <React.Suspense fallback={this.props.fallback}>{this.props.children}</React.Suspense>;
    }

    const stale = STALE_CHUNK.test(error.message || '');
    return (
      <div role="alert" style={{ background: palette.white, borderRadius: 16, border: '1px dashed ' + palette.border, padding: '32px 20px', textAlign: 'center' }}>
        <p style={{ fontFamily: "'Plus Jakarta Sans', sans-serif", fontSize: type.body, color: palette.espresso, margin: '0 0 4px' }}>
          {stale ? 'Ropida was updated while this page was open.' : 'This part of the page did not load.'}
        </p>
        <p style={{ fontFamily: "'Plus Jakarta Sans', sans-serif", fontSize: type.body, color: palette.driftwood, margin: '0 0 16px' }}>
          Reload to continue.
        </p>
        <Btn size="sm" onClick={() => window.location.reload()}>Reload</Btn>
      </div>
    );
  }
}
